module.exports = __webpack_public_path__ + "static/media/ColibrisBlancNoText.eb6c5f3c.png";